import axios from "axios";  
import Vue from 'vue'

export const state = {};

export const getters = { };

export const mutations = {
  
  ClearJWToken() {
    window.$cookies.remove("ecampus",null,Vue.prototype.$config.COOKIES_DOMAIN);  
  },
};
 


export const actions = {


  //GET
  async ActionsGet({dispatch}, Data) {  
    dispatch("auth/TokenRefreshZamanKontrol", '', { root: true })

    return axios 
      .get(
        Data["Service"] +
          "?PageNumber=" +
          Data["Page"].PageNumber +
          "&PageSize=" +
          Data["Page"].PageSize 
      )
      .then((res) => res.data)
      .catch((error) => {  
        if(error.response.status == 401 || error.response.status == 500){    
          dispatch("logOut"); 
          return error.response.data 
        }else{
          return error.response.data 
        }
      });
  },

  //GET Single
  async ActionsSingleGet({dispatch}, Data) {
    dispatch("auth/TokenRefreshZamanKontrol", '', { root: true })

    return axios
      .get(Data["Service"] + "/" + Data["Id"])
      .then((res) => res.data)
      .catch((error) => error.response.data);
  },

  //FİLTER GET 
 async ActionsFilterGet({dispatch}, Data) { 
    dispatch("auth/TokenRefreshZamanKontrol", '', { root: true })
    
  return axios
    .get(
      Data["Service"] +
        "?PageNumber=" +
        Data["Page"].PageNumber +
        "&PageSize=" +
        Data["Page"].PageSize +
        Data["Filter"]
    )
    .then((res) => res.data)
    .catch((error) => {  
      if(error.response.status == 401 || error.response.status == 500){  
        dispatch("logOut"); 
        return error.response.data 
      }else{
        return error.response.data 
      }
    });
}, 
 
  //POST
  async ActionsPost({dispatch}, Data) {
    dispatch("auth/TokenRefreshZamanKontrol", '', { root: true })
    
    return axios
      .post(Data["Service"], Data["Data"])
      .then((res) => res.data)
      .catch((error) => error.response.data).catch(error => { console.log( JSON.parse(JSON.stringify(error.response.data.errors))); }) ;
  }, 
  
  //PUT
  async ActionsPut({dispatch}, Data) {
    dispatch("auth/TokenRefreshZamanKontrol", '', { root: true })
    
    return axios
      .put(Data["Service"] + "/" + Data["Data"].Id, Data["Data"])
      .then((res) => res.data)
      .catch((error) => error.response.data);
    //.catch(error => { console.log( JSON.parse(JSON.stringify(error.response.data.errors))); }) ;
  },

  //PUTList
  async ActionsPutList({dispatch}, Data) {
    dispatch("auth/TokenRefreshZamanKontrol", '', { root: true })
    
    return axios
      .put(Data["Service"], Data["Data"])
      .then((res) => res.data)
      .catch((error) => error.response.data);
    //.catch(error => { console.log( JSON.parse(JSON.stringify(error.response.data.errors))); }) ;
  },

  //DELETE
  async ActionsDelete({dispatch}, Data) {
    dispatch("auth/TokenRefreshZamanKontrol", '', { root: true })
    
    return axios
      .delete(Data["Service"] + "/" + Data["Id"])
      .then((res) => res.data)
      .catch((error) => error.response.data);
  },

  //SABİTLER
  async ActionsSabitGet({dispatch}, Tip) {
    dispatch("auth/TokenRefreshZamanKontrol", '', { root: true })
    
    return axios
      .get("OKeyValues?Tip=" + Tip + "&PageNumber=1&PageSize=9999")
      .then((res) => {
        return res.data;
      });
  },

  //FİLE GET 
  async ActionsFileGet({dispatch}, Data) {  

    return axios({
      url: Data["Service"]+Data["Filter"], // File URL Goes Here
      method: 'GET',
      responseType: 'blob',
  }) .then((res) => res.data)
  .catch((error) => {  
    if(error.response.status == 401){    
      dispatch("logOut"); 
      return error.response.data 
    }else{
      return error.response.data 
    }
  });

 
  }, 
  //FastReport
  async FastReport({dispatch}, Data) {  
    dispatch("auth/TokenRefreshZamanKontrol", '', { root: true })
    axios({
      url: "GenericReport",
      method: "POST",
      responseType: "blob",
      data: Data,
    })
      .then((response) => {
    //YENİ SEKMEDE AÇMAK İÇİN
        let blob = new Blob([response.data], { type: "application/pdf" }),
        url = window.URL.createObjectURL(blob); 
        window.open(url);
      })
      .catch((error) => error.response.data);
    /* DİREK İNDİRMEK İÇİN 
        var fileURL = window.URL.createObjectURL(new Blob([response.data]));
        var fileLink = document.createElement('a'); 
        fileLink.href = fileURL;
        fileLink.setAttribute('download', 'file.pdf');
        document.body.appendChild(fileLink); 
        fileLink.click();
    */
  },
 
};
